import React, { Component } from 'react';
// import ReactDOM from 'react-dom';

// import { PerspectiveCamera, Renderer, Scene } from 'react-three';
// import * as THREE from 'three';
// import { STLViewer from './STLViewer';
// import t1 from '../../assets/3d/p1-upper-1.stl';
// import t2 from '../../assets/3d/p1-upper-2.stl';
// import t3 from '../../assets/3d/p1-upper-3.stl';
// import t4 from '../../assets/3d/p1-upper-4.stl';
// import teo from '../../assets/3d/Teo.stl';
// import STLViewer from 'stl-viewer';

import STLViewer from './STLViewer';
// let STLViewer = require('./STLViewer');

class Teeth extends Component {
  render() {
    // return <div />;
    return (
      <STLViewer
        url={'lol'}
        width={this.props.width}
        height={this.props.height}
        modelColor="#FFF"
        backgroundColor="#333"
        rotate={false}
        orbitControls={true}
        viewImg={this.props.imgNum}
        imgNum={this.props.imgNum}
      />
    );
    // return this.state.images[this.state.tImg];
  }
  // render() {
  //   var aspectratio = this.props.width / this.props.height;
  //   var cameraprops = {
  //     fov: 75,
  //     aspect: aspectratio,
  //     near: 1,
  //     far: 5000,
  //     position: new THREE.Vector3(0, 0, 600),
  //     lookat: new THREE.Vector3(0, 0, 0),
  //   };

  //   return (
  //     <Renderer width={this.props.width} height={this.props.height}>
  //       <Scene
  //         width={this.props.width}
  //         height={this.props.height}
  //         camera="maincamera"
  //       >
  //         <PerspectiveCamera name="maincamera" {...cameraprops} />
  //       </Scene>
  //     </Renderer>
  //   );

  //   {
  //     // var MainCameraElement = (
  //     //   <PerspectiveCamera
  //     //     name="maincamera"
  //     //     fov="75"
  //     //     aspect={this.props.width / this.props.height}
  //     //     near={1}
  //     //     far={5000}
  //     //     position={new THREE.Vector3(0, 0, 600)}
  //     //     lookat={new THREE.Vector3(0, 0, 0)}
  //     //   >
  //     //     <Renderer width={this.props.width} height={this.props.height}>
  //     //       <Scene
  //     //         width={this.props.width}
  //     //         height={this.props.height}
  //     //         camera="maincamera"
  //     //       />
  //     //     </Renderer>
  //     //   </PerspectiveCamera>
  //     // );
  //     // return MainCameraElement;
  //   }
  // }
}

export default Teeth;



// WEBPACK FOOTER //
// ./src/components/Teeth/index.js